// https://internal.msmaster.qa.paypal.com/elmo/experiment/124425
import { ENV_TYPE } from '../../../lib/constants'
import * as pxp from '../lib/pxp'
import store from '../transfer/stores/configureStore'

// 1. Omit the Donate flow until it is migrated to V2 (p2pgatewayserv / graphql)
//    as V1 does not have full support for new supportedCapabilities.
// 2. Omit the PISP/PSD2 flows (Amex, Splitwise, Fidelity, dual control, ...)
//    to avoid legal reviews until it is proven this trmt increases conversion.
//    * See lib/externalConfig/pisp.js -> PISP_PARTNER_SITE_HOSTS
const omittedFlows = [ENV_TYPE.DONATE, ENV_TYPE.PISP]

const isOmittedFlow = () => {
  const { server } = store.getState()
  return omittedFlows.includes(server.env)
}

export function hasFIFailuresEnhancementTrmnt() {
  if (isOmittedFlow()) {
    return false
  }

  return pxp && pxp.isTreatment('Trmt_p2p_fi_failures_enhancement')
}
